import { render, staticRenderFns } from "./CompAjuizamentos.vue?vue&type=template&id=90e496f8&scoped=true&"
import script from "./CompAjuizamentos.vue?vue&type=script&lang=js&"
export * from "./CompAjuizamentos.vue?vue&type=script&lang=js&"
import style0 from "./CompAjuizamentos.vue?vue&type=style&index=0&id=90e496f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e496f8",
  null
  
)

export default component.exports